// extracted by mini-css-extract-plugin
module.exports = {"tabMenu":"Settings_tabMenu__2vAF7","tabItems":"Settings_tabItems__2bAlm","isActive":"Settings_isActive__3S2kA","settingDetails":"Settings_settingDetails__2cLHm"};